// Bilingual dictionary (DE / EN)
export const dict = {
  en: {
    // generic
    appName: "DomainPitch AI",
    tagline: "Turn domain names into deals",
    getStarted: "Get Started",
    login: "Log in",
    logout: "Log out",
    register: "Sign up",
    email: "Email",
    password: "Password",
    cancel: "Cancel",
    save: "Save",
    delete: "Delete",
    create: "Create",
    loading: "Loading...",
    generate: "Generate",
    generating: "Generating...",
    copy: "Copy",
    copied: "Copied to clipboard",
    export: "Export",
    close: "Close",
    back: "Back",
    optional: "optional",
    // nav
    navDashboard: "Dashboard",
    navPortfolios: "Portfolios",
    navPricing: "Pricing",
    navAccount: "Account",
    // landing
    heroTitle: "Turn your domain portfolio into a pitch machine",
    heroSubtitle: "DomainPitch AI writes investor-grade pitch decks, target audience analysis, valuations and ready-to-send outreach emails for every domain you own \u2014 in seconds.",
    heroCta: "Start free \u2014 3 pitches",
    heroSecondary: "See pricing",
    featuresTitle: "Everything a broker needs",
    feat1Title: "AI Pitch Generation",
    feat1Desc: "Claude Sonnet 4.5 crafts a compelling business concept for every domain.",
    feat2Title: "Target ICP Analysis",
    feat2Desc: "Know exactly which buyers to approach and why.",
    feat3Title: "Outbound Emails",
    feat3Desc: "Ready-to-send cold emails with one-click copy.",
    feat4Title: "CSV Import & Batch",
    feat4Desc: "Import hundreds of domains and pitch them all at once.",
    feat5Title: "PDF & CSV Export",
    feat5Desc: "Share professional pitch decks with your team or clients.",
    feat6Title: "Valuation Ranges",
    feat6Desc: "Data-driven price estimates to anchor negotiations.",
    finalCtaTitle: "Ready to sell more domains?",
    finalCtaDesc: "Join brokers using AI to close faster.",
    // auth
    loginTitle: "Welcome back",
    loginSubtitle: "Log in to your DomainPitch workspace",
    registerTitle: "Create your account",
    registerSubtitle: "Start with 3 free pitches \u2014 no card required",
    noAccount: "Don't have an account?",
    haveAccount: "Already have an account?",
    demoHint: "Demo: demo@domainpitch.ai / Demo1234!",
    // pricing
    pricingTitle: "Simple, transparent pricing",
    pricingSubtitle: "Choose the plan that fits your portfolio",
    perMonth: "/mo",
    currentPlan: "Current plan",
    choosePlan: "Choose plan",
    recommended: "Recommended",
    planFreeName: "Free Trial",
    planProName: "Pro",
    planAgencyName: "Agency",
    pitchesLifetime: "3 pitches (one-time)",
    pitchesMonthly: "100 pitches / month",
    pitchesUnlimited: "Unlimited pitches",
    featBatch: "Batch generation",
    featPdf: "PDF export",
    featCsv: "CSV batch export",
    featSingle: "Single pitch generation",
    stripeTrust: "Secure payments \u2022 Cancel anytime",
    stubNotice: "Test mode: plan switches instantly (Stripe goes live later).",
    downgrade: "Downgrade to Free",
    // dashboard
    dashTitle: "Dashboard",
    welcomeBack: "Welcome back",
    statPortfolios: "Portfolios",
    statDomains: "Domains",
    statPitched: "Pitched",
    statSold: "Sold",
    statPitches: "Pitches",
    recentPitches: "Recent pitches",
    noRecentPitches: "No pitches yet. Create a portfolio and generate your first pitch.",
    yourPortfolios: "Your portfolios",
    newPortfolio: "New portfolio",
    createPortfolio: "Create portfolio",
    portfolioName: "Portfolio name",
    portfolioDesc: "Description",
    noPortfolios: "No portfolios yet",
    noPortfoliosDesc: "Create your first portfolio to start organizing domains.",
    domainsCount: "domains",
    open: "Open",
    usageQuota: "Pitch usage",
    unlimited: "Unlimited",
    upgrade: "Upgrade",
    // portfolio detail
    addDomain: "Add domain",
    importCsv: "Import CSV",
    batchGenerate: "Batch generate",
    exportCsv: "Export CSV",
    searchDomains: "Search domains...",
    allStatuses: "All statuses",
    statusNew: "New",
    statusPitched: "Pitched",
    statusSold: "Sold",
    colDomain: "Domain",
    colCategory: "Category",
    colPrice: "Target price",
    colStatus: "Status",
    colActions: "Actions",
    domainNameLabel: "Domain name",
    domainNamePlaceholder: "example.com",
    domainHelp: "Letters, digits, dots and hyphens only \u2014 no https:// or paths",
    categoryLabel: "Category",
    priceLabel: "Target price (EUR)",
    noDomains: "No domains yet",
    noDomainsDesc: "Add domains manually or import a CSV to get started.",
    view: "View",
    markSold: "Mark as sold",
    markNew: "Mark as new",
    csvDialogTitle: "Import domains from CSV",
    csvDialogDesc: "Upload a CSV with a column 'domain_name'. Optional: 'category', 'target_price'.",
    csvChooseFile: "Choose CSV file",
    csvImport: "Import",
    csvResult: "Imported {added} domains, {errors} rows skipped.",
    batchDialogTitle: "Batch generate pitches",
    batchDialogDesc: "Generate pitches for all domains without one yet.",
    batchRun: "Generate all",
    language: "Language",
    // domain detail
    generatePitch: "Generate AI Pitch",
    regenerate: "Regenerate",
    exportPdf: "Export PDF",
    copyEmail: "Copy email",
    tabPitch: "Pitch Deck",
    tabIcp: "Target ICP",
    tabEmail: "Outbound Email",
    tabValuation: "Valuation",
    noPitchYet: "No pitch generated yet",
    noPitchDesc: "Click 'Generate AI Pitch' to create a full pitch package for this domain.",
    domainMeta: "Domain details",
    valuationRange: "Valuation range",
    // account
    accountTitle: "Account & Billing",
    yourPlan: "Your plan",
    manageSub: "Manage subscription",
    accountEmail: "Account email",
    memberSince: "Member since",
    // toasts / errors
    errGeneric: "Something went wrong",
    quotaReached: "Pitch limit reached. Upgrade to continue.",
    featureLocked: "This feature requires a higher plan.",
    domainAdded: "Domain added",
    portfolioCreated: "Portfolio created",
    pitchGenerated: "Pitch generated",
    planUpdated: "Plan updated",
    confirmDelete: "Are you sure? This cannot be undone.",
  },
  de: {
    appName: "DomainPitch AI",
    tagline: "Aus Domains werden Deals",
    getStarted: "Loslegen",
    login: "Anmelden",
    logout: "Abmelden",
    register: "Registrieren",
    email: "E-Mail",
    password: "Passwort",
    cancel: "Abbrechen",
    save: "Speichern",
    delete: "L\u00f6schen",
    create: "Erstellen",
    loading: "L\u00e4dt...",
    generate: "Generieren",
    generating: "Generiere...",
    copy: "Kopieren",
    copied: "In Zwischenablage kopiert",
    export: "Exportieren",
    close: "Schlie\u00dfen",
    back: "Zur\u00fcck",
    optional: "optional",
    navDashboard: "Dashboard",
    navPortfolios: "Portfolios",
    navPricing: "Preise",
    navAccount: "Konto",
    heroTitle: "Verwandle dein Domain-Portfolio in eine Pitch-Maschine",
    heroSubtitle: "DomainPitch AI schreibt investorenreife Pitch-Decks, Zielgruppen-Analysen, Bewertungen und versandfertige Outreach-E-Mails f\u00fcr jede deiner Domains \u2014 in Sekunden.",
    heroCta: "Kostenlos starten \u2014 3 Pitches",
    heroSecondary: "Preise ansehen",
    featuresTitle: "Alles, was ein Makler braucht",
    feat1Title: "KI-Pitch-Generierung",
    feat1Desc: "Claude Sonnet 4.5 erstellt f\u00fcr jede Domain ein \u00fcberzeugendes Gesch\u00e4ftskonzept.",
    feat2Title: "Zielgruppen-Analyse",
    feat2Desc: "Wisse genau, welche K\u00e4ufer du ansprechen solltest \u2014 und warum.",
    feat3Title: "Outbound-E-Mails",
    feat3Desc: "Versandfertige Kaltakquise-E-Mails mit Ein-Klick-Kopie.",
    feat4Title: "CSV-Import & Batch",
    feat4Desc: "Importiere hunderte Domains und pitche sie alle auf einmal.",
    feat5Title: "PDF- & CSV-Export",
    feat5Desc: "Teile professionelle Pitch-Decks mit Team oder Kunden.",
    feat6Title: "Bewertungsspannen",
    feat6Desc: "Datenbasierte Preissch\u00e4tzungen als Verhandlungsanker.",
    finalCtaTitle: "Bereit, mehr Domains zu verkaufen?",
    finalCtaDesc: "Schlie\u00df dich Maklern an, die mit KI schneller abschlie\u00dfen.",
    loginTitle: "Willkommen zur\u00fcck",
    loginSubtitle: "Melde dich in deinem DomainPitch-Workspace an",
    registerTitle: "Konto erstellen",
    registerSubtitle: "Starte mit 3 kostenlosen Pitches \u2014 keine Karte n\u00f6tig",
    noAccount: "Noch kein Konto?",
    haveAccount: "Bereits ein Konto?",
    demoHint: "Demo: demo@domainpitch.ai / Demo1234!",
    pricingTitle: "Einfache, transparente Preise",
    pricingSubtitle: "W\u00e4hle den Plan, der zu deinem Portfolio passt",
    perMonth: "/Mon.",
    currentPlan: "Aktueller Plan",
    choosePlan: "Plan w\u00e4hlen",
    recommended: "Empfohlen",
    planFreeName: "Kostenlos",
    planProName: "Pro",
    planAgencyName: "Agency",
    pitchesLifetime: "3 Pitches (einmalig)",
    pitchesMonthly: "100 Pitches / Monat",
    pitchesUnlimited: "Unbegrenzte Pitches",
    featBatch: "Batch-Generierung",
    featPdf: "PDF-Export",
    featCsv: "CSV-Batch-Export",
    featSingle: "Einzel-Pitch-Generierung",
    stripeTrust: "Sichere Zahlungen \u2022 Jederzeit k\u00fcndbar",
    stubNotice: "Testmodus: Plan wechselt sofort (Stripe folgt sp\u00e4ter).",
    downgrade: "Auf Kostenlos wechseln",
    dashTitle: "Dashboard",
    welcomeBack: "Willkommen zur\u00fcck",
    statPortfolios: "Portfolios",
    statDomains: "Domains",
    statPitched: "Gepitcht",
    statSold: "Verkauft",
    statPitches: "Pitches",
    recentPitches: "Letzte Pitches",
    noRecentPitches: "Noch keine Pitches. Erstelle ein Portfolio und generiere deinen ersten Pitch.",
    yourPortfolios: "Deine Portfolios",
    newPortfolio: "Neues Portfolio",
    createPortfolio: "Portfolio erstellen",
    portfolioName: "Portfolio-Name",
    portfolioDesc: "Beschreibung",
    noPortfolios: "Noch keine Portfolios",
    noPortfoliosDesc: "Erstelle dein erstes Portfolio, um Domains zu organisieren.",
    domainsCount: "Domains",
    open: "\u00d6ffnen",
    usageQuota: "Pitch-Verbrauch",
    unlimited: "Unbegrenzt",
    upgrade: "Upgrade",
    addDomain: "Domain hinzuf\u00fcgen",
    importCsv: "CSV importieren",
    batchGenerate: "Batch generieren",
    exportCsv: "CSV exportieren",
    searchDomains: "Domains suchen...",
    allStatuses: "Alle Status",
    statusNew: "Neu",
    statusPitched: "Gepitcht",
    statusSold: "Verkauft",
    colDomain: "Domain",
    colCategory: "Kategorie",
    colPrice: "Zielpreis",
    colStatus: "Status",
    colActions: "Aktionen",
    domainNameLabel: "Domain-Name",
    domainNamePlaceholder: "beispiel.de",
    domainHelp: "Nur Buchstaben, Ziffern, Punkte und Bindestriche \u2014 kein https:// oder Pfade",
    categoryLabel: "Kategorie",
    priceLabel: "Zielpreis (EUR)",
    noDomains: "Noch keine Domains",
    noDomainsDesc: "F\u00fcge Domains manuell hinzu oder importiere eine CSV.",
    view: "Ansehen",
    markSold: "Als verkauft markieren",
    markNew: "Als neu markieren",
    csvDialogTitle: "Domains aus CSV importieren",
    csvDialogDesc: "Lade eine CSV mit Spalte 'domain_name' hoch. Optional: 'category', 'target_price'.",
    csvChooseFile: "CSV-Datei w\u00e4hlen",
    csvImport: "Importieren",
    csvResult: "{added} Domains importiert, {errors} Zeilen \u00fcbersprungen.",
    batchDialogTitle: "Pitches im Batch generieren",
    batchDialogDesc: "Generiere Pitches f\u00fcr alle Domains ohne Pitch.",
    batchRun: "Alle generieren",
    language: "Sprache",
    generatePitch: "KI-Pitch generieren",
    regenerate: "Neu generieren",
    exportPdf: "PDF exportieren",
    copyEmail: "E-Mail kopieren",
    tabPitch: "Pitch-Deck",
    tabIcp: "Zielgruppe",
    tabEmail: "Outbound-E-Mail",
    tabValuation: "Bewertung",
    noPitchYet: "Noch kein Pitch generiert",
    noPitchDesc: "Klicke auf 'KI-Pitch generieren', um ein komplettes Pitch-Paket zu erstellen.",
    domainMeta: "Domain-Details",
    valuationRange: "Bewertungsspanne",
    accountTitle: "Konto & Abrechnung",
    yourPlan: "Dein Plan",
    manageSub: "Abo verwalten",
    accountEmail: "Konto-E-Mail",
    memberSince: "Mitglied seit",
    errGeneric: "Etwas ist schiefgelaufen",
    quotaReached: "Pitch-Limit erreicht. Upgrade, um fortzufahren.",
    featureLocked: "Diese Funktion erfordert einen h\u00f6heren Plan.",
    domainAdded: "Domain hinzugef\u00fcgt",
    portfolioCreated: "Portfolio erstellt",
    pitchGenerated: "Pitch generiert",
    planUpdated: "Plan aktualisiert",
    confirmDelete: "Sicher? Dies kann nicht r\u00fcckg\u00e4ngig gemacht werden.",
  },
};

export function translate(lang, key, vars) {
  let s = (dict[lang] && dict[lang][key]) || (dict.en && dict.en[key]) || key;
  if (vars) {
    Object.keys(vars).forEach((k) => {
      s = s.replace(`{${k}}`, vars[k]);
    });
  }
  return s;
}
